import MetabaseDashboardsView from './MetabaseDashboardsView';

export default MetabaseDashboardsView;
